/*
---------------------------------
Module - tiles-carousel
---------------------------------
*/

import Glide from '@glidejs/glide'

import {Visible} from 'PlugAndPlay/_global/js/glideExtensions'

import {getCurrentScreenSizeInt} from 'PlugAndPlay/_global/js/screenSize'

import debounce from 'lodash/debounce';

(function ( ) {

    const tilesCarousel = (function () {
        
        let elTileCarousel;
        let glideTileCarousel;
        let isCarouselActive;

        function peekSlideClicked(event) {

            // Only do this if carousel is active
            // This is because on desktop, even if carousel is destroyed, the glide API methods are still active
            if (isCarouselActive) {

                const thisSlide = event.target.closest(".glide__slide");

                if (thisSlide && !thisSlide.classList.contains("glide__slide--visible")) {

                    // Don't go to link
                    event.preventDefault();

                    // This must be a peek slide
                    // Only if the clicked peek slide has a sibling and the sibling has the active class
                    if (thisSlide.nextElementSibling && thisSlide.nextElementSibling.classList.contains("glide__slide--active")) {

                        // This is before the active slide
                        // Scroll back once
                        glideTileCarousel.go('<');

                    } else {

                        // This is after the active slide
                        // Scroll forward once
                        glideTileCarousel.go('>')
                        
                    }

                }

            }

        }

        function initiateCarousel() {

            const settings = {

                // We're not using the peek settings. Relying on overflow: visible and fixed width so that when browser width expands, more overflow part of slide is shown
                type: "carousel",
                gap: 30,
                perView: 4,
                perTouch: 1,
                breakpoints: {
                    
                    1199: {
                        gap: 30,
                        perView: 3,
                        perTouch: 1,
                    },
                    991: {
                        gap: 30,
                        perView: 2,
                        perTouch: 1,
                    },
                    767: {
                        gap: 20,
                        perView: 2,
                        perTouch: 1
                    },
                    575: {
                        gap: 20,
                        perView: 1,
                        perTouch: 1
                    },
                    
                }
    
            };

            // Initiate the carousel
            glideTileCarousel = new Glide(elTileCarousel, settings).mount({

                'Visible': Visible

            });

            elTileCarousel.addEventListener("click", peekSlideClicked);

            isCarouselActive = true;

        }

        // Check the breakpoint on page load and window resize.
        // If big enough, destroy carousel (if not active)
        // If small enough, initiate carousel (if it hasn't already)
        function processBreakpoint() {
            
            var currentScreenSizeInt = getCurrentScreenSizeInt();

            if (currentScreenSizeInt > 5) {

                if (isCarouselActive) {
                    
                    glideTileCarousel.destroy();

                    // Remove all visible classes
                    elTileCarousel.querySelectorAll(".glide__slide--visible").forEach(slide => {
                        slide.classList.remove('glide__slide--visible');
                    });

                    // Remove all tabindex = -1 from all
                    elTileCarousel.querySelectorAll("a[tablink]").forEach(link => {
                        link.setAttribute("tabindex", -1);
                    });

                    isCarouselActive = false;

                }
                
            } else {

                if (!isCarouselActive) {
                    initiateCarousel();
                }
                
            }
                
        }

        function init(element) {

            try {

                elTileCarousel = element;

                processBreakpoint();

                window.addEventListener('resize', debounce(processBreakpoint, 100));

            } catch (error) {
                console.error(error);
            }

        }

        return {
            init: init
        };

    });

    document.addEventListener("DOMContentLoaded", function () {

        let elTileCarousels = document.querySelectorAll(".tile-carousel");

        if (elTileCarousels) {
            
            elTileCarousels.forEach((element) => {
                
                // Instantiate the object instance
                let tileCarouselInstance = tilesCarousel();

                tileCarouselInstance.init(element);

            });

        }

    });

})();
